import * as React from 'react'
import { t } from 'ttag'
import { DivisionCategoryRow, DivisionDto } from '../../services/api.types'
import { ActivityView } from '../../views/Activity/store/ActivityReducer'
import YumLeaderboardTabCompact from '../YumLeaderboardTabs/YumLeaderboardTab/YumLeaderboardTabCompact'
import { translateDivisionCategoryType } from '../../views/TeamManagement/TeamManagement'
import {
  getDivisionCategoryIdFromLeaderboardId,
  isDivisionCategoryLeaderboardId,
} from '../../common/helpers/challenges'
import YumLeaderboardTabs from '../YumLeaderboardTabs/YumLeaderboardTabs'
import YumLeaderboardTabsCompact from '../YumLeaderboardTabs/YumLeaderboardTabsCompact'

export interface YumGoalRankingTabsCompactProps {
  /** Whether to show the tabs at all */
  showTabs: boolean
  /** Current active tab value */
  activityView: ActivityView
  /** Callback when tab changes */
  onTabChange: (event: React.ChangeEvent<{}>, newActivityView: ActivityView) => void
  /** Whether to hide the Individuals tab */
  hidePeopleTab?: boolean
  /** Whether to hide the Teams tab */
  hideGroupsTab?: boolean
  /** Whether to hide the Countries tab */
  hideCountriesTab?: boolean
  /** Whether to show the Collective tab */
  showCollectiveTab?: boolean
  /** Available divisions/teams */
  divisions: DivisionDto[]
  /** Available countries */
  countries: string[]
  /** Available division categories */
  divisionCategories: DivisionCategoryRow[]
  /** Ordered list of enabled leaderboards */
  leaderboards: string[] | null
}

/**
 * Renders the leaderboard tabs for the 2026 layout refresh.
 * Positioned at the top of the ranking view, outside the content wrapper.
 */
export const YumGoalRankingTabsCompact: React.FC<YumGoalRankingTabsCompactProps> = ({
  showTabs,
  activityView,
  onTabChange,
  hidePeopleTab,
  hideGroupsTab,
  hideCountriesTab,
  showCollectiveTab,
  divisions,
  countries,
  divisionCategories,
  leaderboards,
}) => {
  // Don't render anything if tabs should be hidden
  if (!showTabs) {
    return null
  }

  return (
    <YumLeaderboardTabsCompact
      value={activityView}
      onChange={onTabChange}
      // style={{
      //   marginBottom: '8px',
      //   background: 'white',
      //   borderRadius: 8,
      // }}
    >
      {/* Render tabs in the saved order when available */}
      {leaderboards && leaderboards.length > 0
        ? leaderboards.map((leaderboardId) => {
            if (leaderboardId === ActivityView.INDIVIDUAL) {
              return !hidePeopleTab ? (
                <YumLeaderboardTabCompact key={leaderboardId} label={t`Individuals`} value={ActivityView.INDIVIDUAL} />
              ) : null
            }
            if (leaderboardId === ActivityView.GROUP) {
              return !hideGroupsTab && divisions && divisions.length > 0 ? (
                <YumLeaderboardTabCompact key={leaderboardId} label={t`Teams`} value={ActivityView.GROUP} />
              ) : null
            }
            if (leaderboardId === ActivityView.COUNTRY) {
              return !hideCountriesTab && countries && countries.length > 0 ? (
                <YumLeaderboardTabCompact key={leaderboardId} label={t`Countries`} value={ActivityView.COUNTRY} />
              ) : null
            }
            if (leaderboardId === ActivityView.COLLECTIVE) {
              return (
                <YumLeaderboardTabCompact key={leaderboardId} label={t`Collective`} value={ActivityView.COLLECTIVE} />
              )
            }

            if (isDivisionCategoryLeaderboardId(leaderboardId)) {
              const categoryId = getDivisionCategoryIdFromLeaderboardId(leaderboardId)
              const category = divisionCategories?.find((item) => item.id === categoryId)
              if (!category) return null
              const categoryName = translateDivisionCategoryType(category, true)
              return <YumLeaderboardTabCompact key={leaderboardId} label={categoryName} value={leaderboardId as any} />
            }

            return null
          })
        : null}

      {/* Fallback order when leaderboards are not provided */}
      {(!leaderboards || leaderboards.length === 0) && (
        <>
          {!hidePeopleTab && <YumLeaderboardTabCompact label={t`Individuals`} value={ActivityView.INDIVIDUAL} />}
          {!hideGroupsTab && divisions && divisions.length > 0 && (
            <YumLeaderboardTabCompact label={t`Teams`} value={ActivityView.GROUP} />
          )}
          {!hideCountriesTab && countries && countries.length > 0 && (
            <YumLeaderboardTabCompact label={t`Countries`} value={ActivityView.COUNTRY} />
          )}
          {showCollectiveTab && <YumLeaderboardTabCompact label={t`Collective`} value={ActivityView.COLLECTIVE} />}
        </>
      )}
    </YumLeaderboardTabsCompact>
  )
}

export default YumGoalRankingTabsCompact
